module.exports = __webpack_public_path__ + "img/sicepat.c72dac61.png";